export const BUTTONS = [
  { name: "Back", className: "btn-secondary" },
  { name: "Delete", className: "btn-primary" },
];

export const contentDetails = [
  { label: "Name", name: "firstName" },
  { label: "JobTitle", name: "jobTitle" },
  { label: "Mobile", name: "mobileNumber" },
  { label: "State", name: "state" },
  { label: "Email", name: "email" },
];

export const STATE_VALUES = [
  { value: "", label: "Please Select", isDisabled: true },
  { value: "Active", label: "Active", isDisabled: false },
  { value: "Inactive", label: "Inactive", isDisabled: false },
];

export const DELETE_MODAL_SUB_TITLE =
  "Are you sure you want to delete this item?";
export const DELETE_MODAL_TITLE = "Delete Item";
